import { AgmCoreModule, LAZY_MAPS_API_CONFIG } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AgmDirectionModule } from 'agm-direction';
import { NgDragDropModule } from 'ng-drag-drop';
import { config } from '../../../config/config';
import { CommonModule } from '../../common/common.module';
import { ApiErrorHandler } from '../../common/services/api.error.handler';
import { ApiService } from '../../common/services/api.service';
import { AuthService } from '../../common/services/auth.service';
import { DefaultImageWebSideService } from '../../common/services/default.images/default.image.web.side.service';
import { GoogleMapsService } from '../../common/services/google.maps.service';
import { EventGuard } from '../../guards/event.guard';
import { TripPlannerGuard } from '../../guards/trip.planner';
import { AdminSocketService } from '../../services/admin.socket.service';
import { CustomizationApiService } from '../../services/customization.api.service';
import { ExportService } from '../../services/export.csv.service';
import { AuthGuard } from '../../guards/auth.guard';
import { AccountApiService } from '../../services/account.api.service';
import { ConfigService } from '../../services/config.service';
import { EventTimeService } from '../../services/event.time.service';
import { GeoService } from '../../services/geo.service';
import { HubApiService } from '../../services/hub.api.service';
import { ImageService } from '../../services/image.service';
import { SchedulerApiService } from '../../services/scheduler.api.service';
import { VisitorApiService } from '../../services/visitor.api.service';
import {
  HubCalendarStore,
  HubExportPdfStore,
  HubLogoStore,
  InfoStore,
  EditorChoiceStore,
  PDFSettingsStore,
  ToggleStore,
  ToursStore,
  CustomBtnStore,
  CustomDefaultPlaceCategoryStore,
  CustomDefaultPlaceCategoryItemSelectionStore,
  CustomDefaultPlaceCategoryItemEditedStore,
  UpdateGeoLocationStore,
  BulkAIDescriptionsStore,
} from '../../stores/hub.calendar.store';
import { HubCalendarEventsStore } from '../../stores/hub.calendar.store';
import { HubCalendarPlacesStore } from '../../stores/hub.calendar.store';
import { HubFacebookPageFeedsStore } from '../../stores/hub.calendar.store';
import { HubFacebookLocationFeedsStore, ToggleAndDataSourceStore } from '../../stores/hub.calendar.store';
import {
  AllFrontendSettingsStore,
  VisitorCalendarStore,
  VisitorSettingsStore,
  VisitorStyleStore,
  VisitorTripIdStore,
  VisitorTripStore,
  VisitorTripNotifyAddOrRemoveItemStore,
  TravelModeStore,
} from '../../stores/visitor.calendar.store';
import { AccountsComponent } from '../admin/accounts/accounts.component';
import { SetApprovedComponent } from '../admin/accounts/set.approved/set.approved.component';
import { AdminComponent } from '../admin/admin.component';
import { AuthComponent } from '../auth/auth.component';
import { LoginComponent } from '../auth/login/login.component';
import { FallComponent } from '../fall.component';
import { GpsRedirectComponent } from '../gps.redirect.component';
import { HubEventCardComponent } from '../hub/calendar/event.card/hub.event.card.component';
import { HubCalendarComponent } from '../hub/calendar/hub.calendar.component';
import { HubPlaceCardComponent } from '../hub/calendar/place.card/hub.place.card.component';
import { MarketingComponent } from '../hub/customization/marketing/marketing.component';
import { StyleComponent } from '../hub/customization/style/style.component';
import { EventBriteAddComponent } from '../hub/edit.eventbrite/event.brite.add.component';
import { VisitorLargerCardComponent } from '../visitor/calendar/larger.card/visitor.larger.card.component';
import { AttractionListComponent } from '../hub/tours/attractions/attraction.list.component';
import { DirectionPlanComponent } from '../hub/tours/direction.plan/direction.plan.component';
import { TourComponent } from '../hub/tours/tours/tour.component';
import { CreateEventComponent } from '../hub/manually.add/create.event/create.event.component';
// import { EventAddFormComponent } from '../hub/edit.account/event.add.form.component';
import { HubPickThemeComponent } from '../hub/edit.account/pick.theme/hub.pick.theme.component';
import { BlockKeywordsComponent } from '../hub/block.keywords/block.keywords.component';
import { HubComponent } from '../hub/hub.component';
import { CreatePlaceComponent } from '../hub/manually.add/create.place/create.place.component';
import { ManuallyAddComponent } from '../hub/manually.add/manually.add.component';
import { HubNavigatorComponent } from '../hub/side.bar/hub.side.bar.component';
import { UpgradeButtonComponent } from '../hub/upgrade.button/upgrade.button.component';
import { VisitorEventCardComponent } from '../visitor/calendar/event.card/visitor.event.card.component';
import { VisitorPlaceCardComponent } from '../visitor/calendar/place.card/visitor.place.card.component';
import { VisitorSquareCardComponent } from '../visitor/calendar/square.card/visitor.square.card.component';
import { VisitorCalendarComponent } from '../visitor/calendar/visitor.calendar.component';
import { VisitorCreateEventComponent } from '../visitor/create.event/create.event.component';
import { VisitorCreatePlaceComponent } from '../visitor/create.place/create.place.component';
import { LoginWithFacebookModal } from '../visitor/event.details/login.with.facebook.modal/login.with.facebook.modal';
import { VisitorEventDetailsComponent } from '../visitor/event.details/visitor.event.details.component';
import { VisitorEventMapComponent } from '../visitor/event.map/visitor.event.map.component';
import { VisitorPlaceDetailsComponent } from '../visitor/place.details/visitor.place.details.component';
import { VisitorPlaceMapComponent } from '../visitor/place.map/visitor.place.map.component';
import { VisitorSideBarComponent } from '../visitor/side.bar/visitor.side.bar.component';
import { VisitorTopBarComponent } from '../visitor/top.bar/visitor.top.bar.component';
import { VisitorTourCardComponent } from '../visitor/trip/tour.card/visitor.tour.card.component';
import { VisitorTripCardComponent } from '../visitor/trip/trip.card/visitor.trip.card.component';
import { TripFloatDetailComponent } from '../visitor/trip/trip.float.detail/trip.float.detail.component';
import { TripMapBottomInfoComponent } from '../visitor/trip/trip.map.bottom.info/trip.map.bottom.info.component';
import { VisitorTripSideBarComponent } from '../visitor/trip/trip.side.bar/visitor.trip.side.bar.component';
import { VisitorTripComponent } from '../visitor/trip/visitor.trip.component';
import { VisitorComponent } from '../visitor/visitor.component';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { GoogleMapsConfig } from './google.maps.config';
import { PlaceGuard } from 'guards/place.guard';
import {
  VisitorTripPlaceCardComponent
} from 'components/visitor/trip/trip.place.card/visitor.trip.place.card.component';
import { HubNavComponent } from 'components/hub/nav/hub.nav.component';
import { AlertifyService } from 'services/alertify.service';
import { BlockNavigatorComponent } from 'components/visitor/trip/block.navigator/block.navigator.component';
import { FileSelectorComponent } from 'common/components/file.selector/file.selector.component';
import { UploadEventsComponent } from 'components/hub/upload.events/upload.events.component';
import {
  ContentManagementComponent
} from 'components/hub/edit.account/content.management/content.management.component';
import {
  SearchGeofenceComponent
} from 'components/hub/edit.account/content.management/search.geofence/search.geofence.component';
import {
  LocationFeedListComponent
} from 'components/hub/edit.account/content.management/location.feed.list/location.feed.list.component';
import {
  SearchGooglePlaceComponent
} from '../hub/edit.account/content.management/search.google.place/search.google.place.component';
import { RegionComponent } from 'components/hub/tours/regions/region.component';
import { NotFoundGuard } from 'guards/not.found.guard';
import { MediaQueryService } from 'services/media.query.service';
import {
  TripPlannerColorSettingsComponent
} from '../hub/customization/style/trip.planner.color.settings/trip.planner.color.settings.component';
import { CustomizePlaceCategoryComponent } from 'components/hub/place.category/customize.place.category.component';
import { AccordionEditorComponent } from 'components/hub/accordion.editor/accordion.editor.component';
import {
  CustomDefaultPlaceCategoryAccordionComponent
} from '../hub/custom.default.place.category.accordion/custom.default.place.category.accordion.component.';
import { CustomPlaceBtnComponent } from 'components/visitor/custom.place.btn/custom.place.btn.component';
import { HubSimilarCalendarComponent } from '../hub/similar.calendar/hub.similar.calendar.component';
import { AISettingsComponent } from '../hub/ai.settings/ai.settings.component';
import {
  LocationFilterSettingsComponent
} from '../hub/customization/location.filter.settings/location.filter.settings.component';
import { HubSimilarPlaceCalendarComponent } from '../hub/similar.place.calendar/hub.similar.place.calendar.component';
import { KeywordService } from '../../services/keyword.service';
import { V3RedirectGuard } from '../../guards/redirect.to.v3.guard';

export function loadConfiguration(configService: ConfigService, httpClient: HttpClient) {
  return () =>
    configService.load(httpClient).then(() => {
      try {
        console.log('location.hostname', location.hostname);
        FB.init(config.facebook.sdkConfig);
      } catch (e) {
        console.warn(e);
      }
    });
}

@NgModule({
  declarations: [
    AppComponent,

    AuthComponent,
    LoginComponent,

    AdminComponent,
    AccountsComponent,

    HubComponent,
    HubNavComponent,
    HubCalendarComponent,
    HubSimilarCalendarComponent,
    HubSimilarPlaceCalendarComponent,
    HubEventCardComponent,
    HubPlaceCardComponent,
    HubNavigatorComponent,
    HubPickThemeComponent,
    CreateEventComponent,
    CreatePlaceComponent,
    SearchGeofenceComponent,
    SearchGooglePlaceComponent,
    LocationFeedListComponent,
    VisitorCreateEventComponent,
    VisitorCreatePlaceComponent,
    BlockKeywordsComponent,
    AISettingsComponent,
    FileSelectorComponent,
    StyleComponent,
    TripPlannerColorSettingsComponent,
    MarketingComponent,
    TourComponent,
    RegionComponent,
    AttractionListComponent,
    DirectionPlanComponent,
    UpgradeButtonComponent,
    UploadEventsComponent,
    CustomPlaceBtnComponent,

    VisitorComponent,
    VisitorCalendarComponent,
    VisitorEventCardComponent,
    // VisitorSquareCardComponent,
    // VisitorLongCardComponent,
    // VisitorModernBlockCardComponent,
    VisitorLargerCardComponent,
    VisitorEventMapComponent,
    LoginWithFacebookModal,
    VisitorEventDetailsComponent,
    VisitorPlaceDetailsComponent,
    VisitorPlaceCardComponent,
    VisitorPlaceMapComponent,
    VisitorSideBarComponent,
    VisitorTopBarComponent,
    VisitorTripComponent,
    SetApprovedComponent,
    VisitorTripSideBarComponent,
    VisitorTripCardComponent,
    VisitorTripPlaceCardComponent,
    VisitorTourCardComponent,
    TripFloatDetailComponent,
    TripMapBottomInfoComponent,
    BlockNavigatorComponent,

    // EventAddFormComponent,
    EventBriteAddComponent,
    ContentManagementComponent,

    ManuallyAddComponent,
    CustomizePlaceCategoryComponent,
    LocationFilterSettingsComponent,
    // AccordionEditorComponent,
    // CustomDefaultPlaceCategoryAccordionComponent,

    FallComponent,
    GpsRedirectComponent,
  ],
  imports: [
    // ServiceWorkerModule.register('https://imgoingcalendar.com/ngsw-worker.js', { enabled: ((location.hostname.indexOf('imgoing') >= 0) && (location.port !== '4200')) }),
    ServiceWorkerModule.register('https://imgoingcalendar.com/ngsw-worker.js', { enabled: false }),

    CommonModule.forRoot(),

    AppRoutingModule,

    AgmCoreModule.forRoot(),
    AgmSnazzyInfoWindowModule,
    AgmDirectionModule,

    NgDragDropModule.forRoot(),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfiguration,
      deps: [ConfigService, HttpClient],
      multi: true,
    },
    { provide: LAZY_MAPS_API_CONFIG, useClass: GoogleMapsConfig },
    ApiService,
    ApiErrorHandler,
    ConfigService,
    AuthService,
    GoogleMapsService,
    AccountApiService,
    HubApiService,
    ImageService,
    EventTimeService,
    GeoService,
    VisitorApiService,
    ExportService,
    SchedulerApiService,
    CustomizationApiService,
    AdminSocketService,
    DefaultImageWebSideService,
    AlertifyService,
    MediaQueryService,
    KeywordService,

    HubCalendarStore,
    HubFacebookPageFeedsStore,
    HubFacebookLocationFeedsStore,
    VisitorCalendarStore,
    VisitorStyleStore,
    VisitorSettingsStore,
    AllFrontendSettingsStore,
    VisitorTripStore,
    VisitorTripIdStore,
    VisitorTripNotifyAddOrRemoveItemStore,
    HubCalendarEventsStore,
    HubCalendarPlacesStore,
    HubExportPdfStore,
    HubLogoStore,
    PDFSettingsStore,
    ToggleStore,
    ToggleAndDataSourceStore,
    ToursStore,
    CustomBtnStore,
    TravelModeStore,
    CustomDefaultPlaceCategoryStore,
    CustomDefaultPlaceCategoryItemSelectionStore,
    CustomDefaultPlaceCategoryItemEditedStore,
    UpdateGeoLocationStore,
    BulkAIDescriptionsStore,

    InfoStore,
    EditorChoiceStore,

    AuthGuard,
    TripPlannerGuard,
    PlaceGuard,
    EventGuard,
    NotFoundGuard,
    V3RedirectGuard,
  ],
  bootstrap: [AppComponent],
  exports: [],
  entryComponents: [LoginWithFacebookModal],
})
export class AppModule {}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/app/app.module.ts